import type { TimeseriesPeriod } from './timeseries'

export type SourceKind = 'yandex_direct' | 'invite_link' | 'unknown'

export interface TopSource {
  id: string
  kind: SourceKind
  name: string
  hint?: string
  subscribed: number
  cost: number | null
  cpf: number | null
  deltaPct: number | null
  sparkline: number[]
}

export interface TopSourcesResponse {
  from: string
  to: string
  sources: TopSource[]
  totalSources: number
}

const USE_MOCKS = false

function mockSources(): TopSource[] {
  return [
    {
      id: 'yd:campaign:101',
      kind: 'yandex_direct',
      name: '«Поиск 700 03.05» / Москва',
      hint: 'креатив 04 · поиск',
      subscribed: 1284,
      cost: 15921,
      cpf: 12.4,
      deltaPct: 18.2,
      sparkline: [12, 14, 18, 16, 22, 25, 30, 28, 35, 40, 42, 45, 50, 48, 55, 58, 60, 62, 65, 68, 70, 72, 75, 78, 80, 82, 85, 88, 90, 92],
    },
    {
      id: 'yd:campaign:102',
      kind: 'yandex_direct',
      name: 'Реклама в эфире / Утро',
      hint: 'креатив 12 · РСЯ',
      subscribed: 948,
      cost: 14789,
      cpf: 15.6,
      deltaPct: 4.0,
      sparkline: [22, 24, 26, 25, 28, 30, 32, 30, 33, 35, 36, 35, 38, 40, 42, 41, 43, 45, 44, 46, 48, 47, 50, 52, 51, 53, 55, 54, 56, 58],
    },
    {
      id: 'link:custom:7',
      kind: 'invite_link',
      name: 'Реферальная программа',
      hint: 'utm_source=referral',
      subscribed: 762,
      cost: null,
      cpf: null,
      deltaPct: 62.0,
      sparkline: [4, 5, 6, 7, 8, 10, 12, 14, 16, 18, 20, 22, 25, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60],
    },
    {
      id: 'unknown',
      kind: 'unknown',
      name: 'Неизвестный источник',
      hint: 'без UTM и без приглашения',
      subscribed: 512,
      cost: null,
      cpf: null,
      deltaPct: -2.4,
      sparkline: [22, 21, 22, 20, 19, 20, 18, 17, 18, 16, 17, 15, 16, 14, 13, 14, 12, 13, 11, 12, 10, 11, 9, 10, 8, 9, 7, 8, 6, 7],
    },
    {
      id: 'yd:campaign:103',
      kind: 'yandex_direct',
      name: '«Зерно для дома»',
      hint: 'креатив 18 · поиск',
      subscribed: 214,
      cost: 4879,
      cpf: 22.8,
      deltaPct: -12.4,
      sparkline: [18, 17, 16, 15, 14, 13, 12, 13, 12, 11, 10, 11, 10, 9, 10, 9, 8, 9, 8, 7, 8, 7, 6, 7, 6, 5, 6, 5, 4, 5],
    },
  ]
}

export async function getTopSources(
  channelUUID: string,
  period: TimeseriesPeriod = 'month',
  limit = 5,
): Promise<TopSourcesResponse> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 200))
    const today = new Date()
    const from = new Date(today)
    from.setDate(from.getDate() - 30)
    return {
      from: from.toISOString().slice(0, 10),
      to: today.toISOString().slice(0, 10),
      sources: mockSources().slice(0, limit),
      totalSources: 47,
    }
  }
  const res = await fetch(
    `/api/max/dashboard/top-sources?channelUUID=${encodeURIComponent(channelUUID)}&period=${period}&limit=${limit}`,
    { credentials: 'include' },
  )
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
